import { render, staticRenderFns } from "./IconBadgeCheckSolid.vue?vue&type=template&id=f72c3734"
import script from "./IconBadgeCheckSolid.vue?vue&type=script&lang=js"
export * from "./IconBadgeCheckSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports